import _ from 'lodash';

export function authenticationSuccess(context, record) {
  context.gateways.messageGateway.requestSession();
  let gladlyCustomerId = _.get(record, 'gladlyCustomerId');
  if (gladlyCustomerId) {
    context.gateways.messageGateway.setGladlyCustomerId(gladlyCustomerId);
  }
}

export function authUser(context, user) {
  context.gateways.chatGateway.auth(user);
  context.gateways.messageGateway.setGladlyCustomerId(user.gladlyCustomerId);
}
